import Vue from "vue";
import Router from "vue-router";
import Validate from "../views/public/views/Validate.vue";
/* Routes */
import Login from "../views/public/views/Login.vue";
import Home from "../views/private/views/Home.vue";
import Quote from "../views/private/views/Quote.vue";
import Opportunities from "../views/private/views/Opportunities.vue";
import Information from "../views/private/views/Information.vue";
import MyQuotes from "../views/private/views/MyQuotes.vue";
import Card from "../views/private/views/oneclick/Oneclick.vue";

Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/app/:customer",
      component: Home,
      name: "index",
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: "/app/:customer/oportunidades",
      component: Opportunities,
      name: "opportunities",
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: "/app/:customer/cotizaciones",
      component: Quote,
      name: "quote",
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: "/app/:customer/mis-cotizaciones",
      component: MyQuotes,
      name: "myquotes",
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: "/app/:customer/datos",
      component: Information,
      name: "information",
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: "/app/:customer/login",
      component: Login,
      name: "login",
      beforeEnter: (to, from, next) => {
        const isLoggedIn = Vue.auth.check();
        if (isLoggedIn) {
          return next({ path: "/app/" + to.params.customer });
        }
        next();
      },
      props: true,
    },
    {
      path: "/app/:customer/tarjetas",
      component: Card,
      name: "user",
      meta: {
        auth: false,
      },
      props: true,
    },
    {
      path: "/validate",
      component: Validate,
      name: "validate",
      props: true,
    },
  ],
});
